// ToggleTema.jsx — Tombol toggle dark/light mode
import React from 'react';
import { useTheme } from './ThemeContext';

export default function ToggleTema() {
  const { isDark, setTema } = useTheme();

  return (
    <div className="flex items-center justify-between px-4 py-3.5">
      <div className="flex items-center gap-3">
        <span className="text-lg">{isDark ? '🌙' : '☀️'}</span>
        <div>
          <p style={{ color: 'var(--text-primary)' }} className="text-sm font-medium">
            {isDark ? 'Mode Gelap' : 'Mode Terang'}
          </p>
          <p style={{ color: 'var(--text-muted)' }} className="text-xs">
            Tampilan aplikasi
          </p>
        </div>
      </div>

      {/* Toggle switch */}
      <button
        onClick={() => setTema(isDark ? 'light' : 'dark')}
        className="relative w-12 h-6 rounded-full transition-all duration-300 focus:outline-none"
        style={{
          backgroundColor: isDark ? 'var(--accent)' : 'var(--border2)',
        }}
      >
        <div
          className="absolute top-0.5 w-5 h-5 rounded-full shadow-md transition-all duration-300"
          style={{
            backgroundColor: isDark ? 'var(--bg-card)' : '#FFFFFF',
            left: isDark ? '26px' : '2px',
          }}
        />
      </button>
    </div>
  );
}
